import { useEffect } from 'react'
import { useVADController } from '@/features/avatar/manage-vad-state/model/use-vad-controller'

interface UseVADSynchronizerParams {
  vadController: ReturnType<typeof useVADController>
  isConsentVisible: boolean
  currentChatMode: 'voice' | 'chat'
  isMicOn: boolean
  isLoading: boolean
  isSpeaking: boolean
  isAudioPlaying: boolean
}

/**
 * VAD 상태 동기화 Hook
 *
 * 책임:
 * - 다양한 입력 상태를 감지하여 VAD 컨트롤러에 전달
 * - Consent, ChatMode, Mic 상태 변경 감지
 */
export const useVADSynchronizer = ({
  vadController,
  isConsentVisible,
  currentChatMode,
  isMicOn,
  isLoading,
  isSpeaking,
  isAudioPlaying,
}: UseVADSynchronizerParams) => {
  useEffect(() => {
    const vadInputs = {
      isConsentVisible,
      currentChatMode,
      isMicOn,
      isLoading,
      isSpeaking,
      isAudioPlaying,
    }

    // VAD 컨트롤러에서 상태 업데이트
    vadController._updateVADState(vadInputs)
  }, [
    vadController,
    isConsentVisible,
    currentChatMode,
    isMicOn,
    isLoading,
    isSpeaking,
    isAudioPlaying,
  ])
}
